{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Double Drop",
  "alternateName": [
    "дабл дроп кс", "double drop cs", "кс го дабл",
    "doubledrop cs", "cs go double", "cs double"
  ],
  "description": "Игра Double Drop – шанс выиграть удвоенную ставку, выбирая цвет.",
  "url": "https://6cs.fail/ru/double"
}
